import { FunctionComponent } from 'react';

export interface Props {
  direction: 'up' | 'down';
}

const Arrow: FunctionComponent<Props> = ({ direction }) => <i className={`Arrow Arrow--${direction}`} />;

export default Arrow;
